import React from "react";
import {NavLink} from "react-router-dom";

function TableRow(props) {
    return (
        <tr>
            <td className="fieldWrapper"><NavLink to={`/service_cases/service_case/${props.data.id}`}>{props.data.Cislo}</NavLink></td>
            <td className="fieldWrapper" style={{whiteSpace: 'pre-line'}}>{props.data.Produkty}</td>
            <td className="fieldWrapper" style={{whiteSpace: 'pre-line'}}>{props.data.Pristroje}</td>
            <td className="fieldWrapper">{props.data.Nadpis}</td>
            <td className="fieldWrapper">{props.data.Zakaznik}</td>
            <td className="fieldWrapper">{props.data.Stav}</td>
            <td className="fieldWrapper">{props.data.Trvanie}</td>
        </tr>
    )
}

export default TableRow
